import { useQuery } from "react-query";

import { applicationListService } from "services";

const useApplicationCounters = () =>
	useQuery(
		"applicationCounters",
		applicationListService.getApplicationsCounters,
		{ cacheTime: 0 },
	);

export default useApplicationCounters;
